module.exports = __webpack_public_path__ + "school/img/3jidifang.d4e8c99b.jpg";